export const addTimezoneAbbreviationToLabels = (
  labels: string[],
  timezoneAbbreviation: string,
): string[] => {
  return labels.map((label) => `${label} (${timezoneAbbreviation})`)
}
